import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { isSaaS } from 'utils/isSaaS';
import { selectEnabled } from 'store/common/toggle';

const SamoletHeader = React.lazy(() => import('./SamoletHeader'));

const SaasHeader = React.lazy(() => import('./SaasHeader/'));

const Header: React.FC = () => {
  const isSaasHeaderEnabled = useSelector(selectEnabled('newHeader'));
  const Target = isSaaS() && isSaasHeaderEnabled ? SaasHeader : SamoletHeader;

  return (
    <Suspense fallback={null}>
      <Target />
    </Suspense>
  );
};

export default Header;
